<template>
  <base-item-group :item="item" text sub-group />
</template>

<script>
export default {
  name: "ItemSubGroup",

  props: {
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: [],
      }),
    },
  },
};
</script>
<style>
.v-list-item__icon {
  /* margin-right: 6px; */
  margin-right: 0px !important;
  margin-left: 0px !important;
}
</style>
